import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { SentryFeedbackService } from './core/sentry/feedback.service';
import { ToastComponent } from './shared/ui/toast/toast.component';

@Component({
  selector: 'us-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent],
  template: `
    <router-outlet />
    <app-toast />
  `
})
export class AppComponent {
  constructor(private readonly _sentryFeedback: SentryFeedbackService) {}
}
